export default __webpack_public_path__ + "static/media/change-page-tutorial.9f11d909.png";